/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector } from '@angular/core';
import { FormEditCreateUpdateCustomerFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/customer/create-edit/form-edit-create-update-customer-field-dialog.component';
/* eslint-enable */

export class FormEditCustomerFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateCustomerFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateCustomerFieldDialogComponent)
      .create(this.injector);
  }

}
